const ACCESS_TOKEN_KEY = 'accessToken';
// const REFRESH_TOKEN_KEY = 'refreshToken';

export const storage = {
  setAccessToken(token: string) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  },

  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  removeAccessToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  },

//   setRefreshToken(token: string) {
//     localStorage.setItem(REFRESH_TOKEN_KEY, token);
//   },

//   getRefreshToken(): string | null {
//     return localStorage.getItem(REFRESH_TOKEN_KEY);
//   },

//   removeRefreshToken() {
//     localStorage.removeItem(REFRESH_TOKEN_KEY);
//   },

  clearAll() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    // localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
};
